import APIClient from '@/shared/http/clients/apiupload.js'

const resourceName = 'deslocamentos'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=id,desc&`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetActive = (config = {}) => APIClient.get(`${APICore}/${resourceName}/ativo`, config)
const GetCoordinates = (deslocamentoId, config = {}) => APIClient.get(`${APICore}/${resourceName}/${deslocamentoId}/coordenadas`, config)
const StartDeslocamento = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/iniciar`, data, config)
const FinishDeslocamento = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/finalizar`, data, config)
const CheckIn = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/check-in`, data, config)
const CheckInAndCreatePerson = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/check-in-create-person`, data, config)
const CheckOut = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/check-out`, data, config)

const FollowupRepository = {
  GetAll,
  GetAllPaging,
  GetActive,
  GetCoordinates,
  StartDeslocamento,
  FinishDeslocamento,
  CheckIn,
  CheckInAndCreatePerson,
  CheckOut
}

export default FollowupRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/deslocamento/deslocamento.js